/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesRoutingModule
 * Purpose		: Routing module for EmployeeTerritories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EmployeeTerritoriesListComponent } from './EmployeeTerritoriesList.component';
import { EmployeeTerritoriesAddComponent }  from './EmployeeTerritoriesAdd.component';
import { EmployeeTerritoriesEditComponent } from './EmployeeTerritoriesEdit.component';
import { EmployeeTerritoriesDetailsComponent } from './EmployeeTerritoriesDetails.component';

const EmployeeTerritoriesRoutes: Routes = [
	{ path: 'EmployeeTerritories',  component: EmployeeTerritoriesListComponent },
	{ path: 'EmployeeTerritories/add', component: EmployeeTerritoriesAddComponent },
	{ path: 'EmployeeTerritories/:id', component: EmployeeTerritoriesEditComponent },
	{ path: 'EmployeeTerritories/Details/:id', component: EmployeeTerritoriesDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(EmployeeTerritoriesRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class EmployeeTerritoriesRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/EmployeeTerritories/EmployeeTerritories-routing.module.ts